module.exports = __webpack_public_path__ + "static/media/bafd48ef.jpg";